import { apiClient, type ManualCommandConfig } from '@/services/http/client'
import { decodeJwtClaims } from '@/services/auth/mappers'

// Accept only a live Security-verified renewal of this exact platform session.
export async function renewPlatformToken(prior: string, code: string): Promise<string> {
  const original = decodeJwtClaims(prior)
  if (original?.scope !== 'platform' || !original.session_id || !original.user_id)
    throw new Error('Platform session required')
  const result = await apiClient.post('/auth/platform/step-up', { mfa_code: code.trim() }, { manualCommand: true } as ManualCommandConfig)
  const token = result.data?.access_token
  if (typeof token !== 'string') throw new Error('Verified renewal unavailable')
  const check = await apiClient.post('/auth/verify', { token }, { manualCommand: true } as ManualCommandConfig)
  const claims = check.data?.claims
  if (!check.data?.valid || claims?.scope !== 'platform' || claims.tenant_id || claims.ca_firm_id ||
      claims.user_id !== original.user_id || claims.session_id !== original.session_id)
    throw new Error('Platform session changed during verification')
  return token
}
